import { createFileRoute } from '@tanstack/react-router'
import { RialDepositRequestsTable } from '@/features/rial-deposit-requests'

export const Route = createFileRoute(
  '/_authenticated/wallet/rial-deposit-requests'
)({
  component: RialDepositRequestsPage,
})

function RialDepositRequestsPage() {
  return <RialDepositRequestsTable />
}
